import { render } from "./ItemProfileTabs.vue?vue&type=template&id=a9e33aae&scoped=true"
import script from "./ItemProfileTabs.vue?vue&type=script&lang=ts"
export * from "./ItemProfileTabs.vue?vue&type=script&lang=ts"

import "./ItemProfileTabs.vue?vue&type=style&index=0&id=a9e33aae&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a9e33aae"

export default script